import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=62435d8c&scoped=true"
import script from "./DocumentsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSection.vue?vue&type=script&lang=js"
import style1 from "./DocumentsSection.vue?vue&type=style&index=1&id=62435d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62435d8c",
  null
  
)

export default component.exports